import { CHAT_BOT_STATE_UPDATE } from 'ducks/chat/actionTypes/botState'

export function doUpdateChatBotState(mxEvent) {
  return async dispatch => {
    return dispatch({
      type: CHAT_BOT_STATE_UPDATE,
      payload: mxEvent.getContent(),
    })
  }
}
